import { render, staticRenderFns } from "./FormPrdGoiDichVu.vue?vue&type=template&id=e16a4234&scoped=true&"
import script from "./FormPrdGoiDichVu.vue?vue&type=script&lang=js&"
export * from "./FormPrdGoiDichVu.vue?vue&type=script&lang=js&"
import style0 from "./FormPrdGoiDichVu.vue?vue&type=style&index=0&id=e16a4234&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16a4234",
  null
  
)

export default component.exports